import { render, staticRenderFns } from "./InfoWidgetsOteador.vue?vue&type=template&id=e4890042&scoped=true"
import script from "./InfoWidgetsOteador.vue?vue&type=script&lang=js"
export * from "./InfoWidgetsOteador.vue?vue&type=script&lang=js"
import style0 from "./InfoWidgetsOteador.vue?vue&type=style&index=0&id=e4890042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4890042",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Oteador/InfoWidgetsOteador.vue
// module id = sVhv
// module chunks = 41